import React from 'react';
import {Icon, Tooltip} from 'antd';
import VBQLArea from '../../views/VBQLArea';
import Button from '../../views/StyledButton';
import FieldButtons from '../../views/FieldButtons';
import SchemaMenu from './SchemaMenu';

export default ({
                  chooseQueryOrderBy, queryModel, schema, schemaMenuClick,
                  tabKey,
                }) => (
  <React.Fragment>
    <FieldButtons>
         <span className="add-button">
           <SchemaMenu
             root={schema}
             type="order"
             onClick={(item, advanced, desc) => {
               schemaMenuClick(item, 'order', advanced, desc);
             }}
           />
         </span>
      {/* <Tooltip title="Clear 'ORDER BY'">
        <Button type="default" size="small" onClick={() => chooseQueryOrderBy('')} className="close-button"><Icon type="stop" /></Button>
      </Tooltip> */}
    </FieldButtons>
    <div className="cm-size-50">
      {tabKey === 'queryDivided' && <VBQLArea
        placeholder="enter the 'ORDER BY' part of your query"
        value={queryModel.order}
        onChange={chooseQueryOrderBy}
      />}
    </div>
  </React.Fragment>
);
